import React from "react";
import { observer } from "mobx-react";
import { PublisherCollectingSocietyViewStore } from "../../store";
import { PublisherCollectingSocietyViewForm } from "./PublisherCollectingSocietyViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type PublisherCollectingSocietyViewProps = {
  publisherCollectingSocietyViewStore: PublisherCollectingSocietyViewStore;
};

export const PublisherCollectingSocietyView: React.FC<PublisherCollectingSocietyViewProps> =
  observer(({ publisherCollectingSocietyViewStore }) => {
    return (
      <div>
        <PublisherCollectingSocietyViewForm
          collectingSocietyValue={
            publisherCollectingSocietyViewStore.collectingSocietyValue
          }
          cmsAccountNumber={
            publisherCollectingSocietyViewStore.cmsAccountNumberValue
          }
          onPrint={(handlePrint: () => void) =>
            publisherCollectingSocietyViewStore.printPublisherCollectingSociety(
              handlePrint
            )
          }
          onCancel={() =>
            publisherCollectingSocietyViewStore.cancelPublisherCollectingSociety()
          }
          onEdit={
            publisherCollectingSocietyViewStore.isEditEnabled
              ? () =>
                  publisherCollectingSocietyViewStore.editPublisherCollectingSociety()
              : undefined
          }
        />
        <ErrorDialog
          open={publisherCollectingSocietyViewStore.errorDialogOpened}
          title={publisherCollectingSocietyViewStore.errorTitle}
          description={publisherCollectingSocietyViewStore.errorDescription}
          onClose={() => publisherCollectingSocietyViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
